// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"NavItem_menuItem__3ooEz","menuLink":"NavItem_menuLink__2hnLJ"};